export default "__VITE_ASSET__D76u5OVf__"